// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_MigrarLaudosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de POST /migration/laudos/migrar-todas
 * (controllers/migration/laudos.php::migrar_todas).
 *
 * O fechamento da carga de laudos de UMA franquia: o run, a contabilidade dos
 * quatro desfechos por lista (`por_tipo`), os dois contadores da varredura
 * GLOBAL de fotos (alheias e sem pai — silenciosas por desenho, ver
 * LaudoMigrationService), e o desfecho de cada linha.
 *
 * `migradas + skipped + bloqueadas + falhas == total`, sempre.
 */
import type { Migration_LaudoResultadoRow } from './Migration_LaudoResultadoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Migration_MigrarLaudosResponseDados {
run_id: number
total: number
migradas: number
skipped: number
bloqueadas: number
falhas: number
fotos_de_outras_franquias: number
fotos_sem_item_no_ledger: number
por_tipo: Record<string, Record<string, number>>
erros_zoho: string[]
resultados: Migration_LaudoResultadoRow[]
}

export type Migration_MigrarLaudosResponse = ApiResponse<Migration_MigrarLaudosResponseDados>;

registerResponseContract('Migration_MigrarLaudosResponse', {
  run_id:                    { type: 'number',  required: true },
  total:                     { type: 'number',  required: true },
  migradas:                  { type: 'number',  required: true },
  skipped:                   { type: 'number',  required: true },
  bloqueadas:                { type: 'number',  required: true },
  falhas:                    { type: 'number',  required: true },
  fotos_de_outras_franquias: { type: 'number',  required: true },
  fotos_sem_item_no_ledger:  { type: 'number',  required: true },
  por_tipo:                  { type: 'object',  required: true },
  erros_zoho:                { type: 'array',   required: true },
  resultados: {
    type: 'array',
    required: true,
    items: {
      zoho_id:        { type: 'string',  required: false },
      nome:           { type: 'string',  required: false },
      tipo:           { type: 'string',  required: false },
      status:         { type: 'string',  required: false },
      run_id:         { type: 'number',  required: false },
      linha_local_id: { type: 'number',  required: false },
      blockers: {
        type: 'array',
        required: false,
        items: {
          code:     { type: 'string',  required: false },
          message:  { type: 'string',  required: false },
          severity: { type: 'string',  required: false },
          entity:   { type: 'string',  required: false },
          zoho_id:  { type: 'string',  required: false },
          label:    { type: 'string',  required: false },
        },
      },
      erro:           { type: 'string',  required: false },
    },
  },
})
